/**
 * @generated SignedSource<<deaa70b4f28ae272039e59e571f7a7aa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoleRelayWrapper_viewer$data = {
  readonly company: {
    readonly currency: string | null;
    readonly taskTotals: {
      readonly registeredMinutes: number | null;
      readonly billableActualMinutes: number | null;
      readonly nonBillableActualMinutes: number | null;
      readonly estimatePoints: number | null;
      readonly estimateMinutes: number | null;
      readonly remainingPoints: number | null;
      readonly remainingMinutes: number | null;
      readonly plannedRevenue: number | null;
      readonly actualRevenue: number | null;
      readonly remainingRevenue: number | null;
      readonly forecastRevenue: number | null;
      readonly recognitionLockedRevenue: number | null;
      readonly recognitionOpenRevenue: number | null;
      readonly recognitionForecastRevenue: number | null;
      readonly totalActualRevenueRecognition: number | null;
      readonly totalForecastRevenueToComplete: number | null;
      readonly surplus: number | null;
      readonly numberOfTasks: number | null;
    } | null;
    readonly allRolesGlobalSearch: {
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      };
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly name: string | null;
          readonly taskTotals: {
            readonly registeredMinutes: number | null;
            readonly billableActualMinutes: number | null;
            readonly nonBillableActualMinutes: number | null;
            readonly estimatePoints: number | null;
            readonly estimateMinutes: number | null;
            readonly remainingPoints: number | null;
            readonly remainingMinutes: number | null;
            readonly plannedRevenue: number | null;
            readonly actualRevenue: number | null;
            readonly remainingRevenue: number | null;
            readonly forecastRevenue: number | null;
            readonly recognitionLockedRevenue: number | null;
            readonly recognitionOpenRevenue: number | null;
            readonly recognitionForecastRevenue: number | null;
            readonly totalActualRevenueRecognition: number | null;
            readonly totalForecastRevenueToComplete: number | null;
            readonly surplus: number | null;
            readonly numberOfTasks: number | null;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"RoleDropdown_roles">;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "RoleRelayWrapper_viewer";
};
export type RoleRelayWrapper_viewer$key = {
  readonly " $data"?: RoleRelayWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoleRelayWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "convertToProjectCurrency",
  "variableName": "convertToProjectCurrency"
},
v1 = {
  "kind": "Variable",
  "name": "searchQuery",
  "variableName": "searchQuery"
},
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "registeredMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "billableActualMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "nonBillableActualMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "estimatePoints",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "estimateMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingPoints",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingMinutes",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "plannedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actualRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "remainingRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "forecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionLockedRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionOpenRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "recognitionForecastRevenue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalActualRevenueRecognition",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalForecastRevenueToComplete",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "surplus",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "numberOfTasks",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "convertToProjectCurrency"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoleRelayWrapper_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "noRole",
              "value": true
            },
            (v1/*: any*/)
          ],
          "concreteType": "TaskTotals",
          "kind": "LinkedField",
          "name": "taskTotals",
          "plural": false,
          "selections": (v2/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            (v1/*: any*/)
          ],
          "concreteType": "RoleTypeConnection",
          "kind": "LinkedField",
          "name": "allRolesGlobalSearch",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "RoleTypeEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RoleDropdown_roles"
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Role",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "name",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": [
                        (v0/*: any*/),
                        (v1/*: any*/)
                      ],
                      "concreteType": "TaskTotals",
                      "kind": "LinkedField",
                      "name": "taskTotals",
                      "plural": false,
                      "selections": (v2/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "0e449ac5907501b1181d5df2eb79119b";

export default node;
